<template>
  <div>
        <error-msg-component :messages="messages"
                             :error="error"
                             :title="'annulerReglement.messages.errorTitle'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
    <detail-info-remise-bancaire
      v-if="isDetail"
      :remiseBancaire="remiseBancaire">
    </detail-info-remise-bancaire>
    <edit-info-remise-bancaire
      v-else
      :remiseBancaire="remiseBancaire">
    </edit-info-remise-bancaire>
    <div v-if="detailRemiseBancaire.length === 0 && isDetail">
      <div class="card mgt-20px">
        <div class="card-content has-text-centered pd-40px">
          <h1 class="title is-size-3">
            {{ $t('detailRemiseBancaire.messages.info.titreRemiseBancaireEmpty')}}
          </h1>
          <p>
            {{ $t('detailRemiseBancaire.messages.info.sousTitreRemiseBancaireEmpty')}}
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="level mgt-20px">
        <div class="level-left">
          <div class="columns">
            <div class="column is-narrow">
              <selecteur-actions
                @handleAction="handleAction"
                :options='actions'
                :placeholder='$t("general.placeHolder.groupedAction")'
                :titleButton="'general.button.apply'"
                :elementsSelectionnes="isReglementSelected"
              ></selecteur-actions>
            </div>
            <div class="column is-narrow">
              <form @submit.prevent="filter = filterInput">
                <b-input :placeholder="$t('general.button.search')"
                         type="search" icon="magnify"
                         v-model="filterInput">
                </b-input>
              </form>
            </div>
          </div>
        </div>
        <div class="level-right columns">
          <div class="column is-narrow" v-if="!isDetail">
            <button class="button is-addOrEdit"
                    @click="addReglementByPiece()">
              {{ $t('modifRemiseBancaire.actions.addReglement') }}
            </button>
          </div>
          <div class="column is-narrow">
            <exportExcelButton
              :perm="constantes.REMISES_BANCAIRES.exporter"
              in-progress/>
          </div>
        </div>
      </div>
      <v-client-table :data="detailRemiseBancaireFilter" :columns="columns" :options="options"
                      class="tableWithChildRow">
        <div slot="selected" slot-scope="props" class="has-text-centered">
          <b-checkbox :value="props.row.selected"
                      @input="selectionReglement(props.row)"
                      :class="{'disabled': estValide }">
          </b-checkbox>
        </div>
        <div slot="nomCommercial" slot-scope="props" class="is-pulled-left">
          <router-link-blank
            :to="{ name: 'c.bodac.clients/contacts-client', params: {id: props.row.tiers.id}}"
            :message="props.row.tiers.nomCommercial"
          />
        </div>
        <div slot="dateEffet" slot-scope="props" class="is-pulled-left">
          {{ props.row.ligneRemiseBancairePseudoEntity.dateEffet !== null ?
          props.row.ligneRemiseBancairePseudoEntity.dateEffet : null | formatDate }}
        </div>
        <div slot="dateMouvement" slot-scope="props" class="is-pulled-left">
          {{ props.row.dateMouvement | formatDate }}
        </div>
        <div slot="montant" slot-scope="props" class="is-pulled-right">
          {{ props.row.credit - props.row.debit | formatDevise}}
        </div>
        <div slot="edit" slot-scope="props" class="has-text-centered">
          <a @click="checkPermissions(constantes.REMISES_BANCAIRES.maj)
          ? editReglementByPiece(props.row) : showPopUp">
              <b-icon icon="pencil-box-outline"
                      type="is-success"
                      :class="{'text-access-no-permission' :
                    !checkPermissions(constantes.REMISES_BANCAIRES.maj)}"></b-icon>
          </a>
        </div>
        <div slot="delete" slot-scope="props" class="has-text-centered">
          <a @click="checkPermissions(constantes.REMISES_BANCAIRES.supprimer) ?
          singleReglementDelete(props.row) : showPopUp()">
          <b-tooltip type="is-primary"
              position="is-left"
              :label="$t('supprimerReglement.tooltip')">
            <b-icon icon="delete-forever"
                    type="is-danger"
                    :class="{'text-access-no-permission' :
                    !checkPermissions(constantes.REMISES_BANCAIRES.supprimer)}">
            </b-icon>
          </b-tooltip>
          </a>
        </div>
        <div slot="cancelPayment" slot-scope="props" class="has-text-centered">
          <b-tooltip :type="getTooltipColor(props.row)"
            position="is-left"
            :label="getlabelTooltipCancellation(props.row)">
            <a @click="checkPermissions(constantes.REMISES_BANCAIRES.maj) ?
              cancelSinglePayment(props.row) : showPopUp()"
              :class="{'disabled' : !canCancelReglement(props.row)}">
              <b-icon icon="close-circle"
                type="is-danger"
                :class="{'text-access-no-permission' :
                    !checkPermissions(constantes.REMISES_BANCAIRES.maj)}">
              </b-icon>
            </a>
          </b-tooltip>
        </div>
        <template slot='appendBody'>
          <table-footer-totaux
            ref="tableTotaux"
            :columns="columns"
            :target="targetTotal"
            :items="detailRemiseBancaireFilter">
          </table-footer-totaux>
        </template>
      </v-client-table>
      <b-modal v-model="popUpSuppression" has-modal-card class="modal">
        <app-pop-up-prevention oncancel="closePopUpSuppression()"
                               :messHeader="messHeaderSuppression"
                               :messFooter="messFooterSuppression"
                               :cancel="$t('supprimerReglement.no')"
                               :validate="$t('supprimerReglement.yes')"
                               @no="closePopUpSuppression()"
                               @yes="deleteReglement()">
        </app-pop-up-prevention>
      </b-modal>
      <b-modal v-model="popUpAnnulation" has-modal-card class="modal">
        <app-pop-up-prevention oncancel="fermerPopupAnnulation()"
                               :messHeader="messHeaderAnnulation"
                               :messFooter="messFooterAnnulation"
                               :cancel="$t('annulerReglement.no')"
                               :validate="$t('annulerReglement.yes')"
                               :msgAvertissements="msgAvertissements"
                               :questions="questions"
                               :messagesPopup="messagesPopup"
                               :isErrorPopup="errorPopup"
                               :messagesChampsVide="messagesChampsVidePopup"
                               :champsVide="champsVidePopup"
                               @no="fermerPopupAnnulation()"
                               @validateQuestions="cancelReglement">
        </app-pop-up-prevention>
      </b-modal>
      <b-modal v-model="popUpSingleAnnulation" has-modal-card class="modal">
        <popup-annulation-reglement oncancel="fermerPopupAnnulation()"
                               :reglementAAnnuler="reglementAAnnuler"
                               :remiseBancaire="remiseBancaire"
                               @updateMouvementClient="updateMouvementClient"
                               @no="fermerPopupAnnulation()"
                               @yes="cancelReglement()">
        </popup-annulation-reglement>
      </b-modal>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import popUpSuppression from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { remove as deleteReglement } from '@/api/reglement/index';
import { annulerPaiementsAsync } from '@/api/mouvementClient/index';
import { sauvegarde as saveLettrage } from '@/api/lettrage/index';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import messageSucces from '@/services/general/messageSucces';
import formatIsoDate from '@/services/general/formatIsoDate';
import validationReglement from '@/services/reglement/validation/validationReglement';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { VALIDE } from '@/configuration/remiseBancaire/remiseBancaireConf';
import childRowDetailReglementVente from '@/components/remiseBancaire/c_childRowDetailReglementVente';
import { REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';
import { LETTRAGE_TYPE_ANNULATION_REGLEMENT as ANNULATION_REGLEMENT } from '@/configuration/lettrageConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { ACTION_DELETE, ACTION_MASS_ANNULATION } from '@/configuration/general/actionsConf';
import selecteurActions from '@/components/general/selecteurAction';
import editInfoRemiseBancaire from '@/components/bodac/remiseBancaire/edit/m_infoRemiseBancaire';
import detailInfoRemiseBancaire from '@/components/bodac/remiseBancaire/detail/c_infoRemiseBancaire';
import { SENS_VENTE } from '@/configuration/devisConf';
import popupAnnulationReglement from '@/components/remiseBancaire/p_annulationReglement';
import validationGeneral from '@/services/validation/validation';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import translate from '@/services/remiseBancaire/validation/champsRemiseBancaireTranslator';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    detailRemiseBancaire: {
      type: Array,
      required: true,
    },
    remiseBancaire: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesPopup: [],
      error: false,
      messagesChampsVide: [],
      champsVidePopup: [],
      messagesChampsVidePopup: [],
      errorPopup: false,
      reglementASupp: [],
      reglementAAnnuler: [],
      questions: [],
      popUpSuppression: false,
      popUpAnnulation: false,
      popUpSingleAnnulation: false,
      filter: '',
      filterInput: '',
      constantes: {
        REMISES_BANCAIRES,
        ANNULATION_REGLEMENT,
      },
      actions: [],
      msgAvertissements: [],
    };
  },
  components: {
    routerLinkBlank,
    errorMsgComponent,
    appPopUpPrevention: popUpSuppression,
    selecteurActions,
    editInfoRemiseBancaire,
    detailInfoRemiseBancaire,
    popupAnnulationReglement,
    tableFooterTotaux,
    exportExcelButton,
  },
  methods: {
    getTooltipColor(reglement) {
      if (this.canCancelReglement(reglement)) return 'is-primary';
      return 'is-danger';
    },
    canCancelReglement(reglement) {
      return reglement.lettrages.length
        && !reglement.lettrages.find(l => l.lettrageType === this.constantes.ANNULATION_REGLEMENT);
    },
    getlabelTooltipCancellation(reglement) {
      if (!reglement.lettrages.length) {
        return this.$t('annulerReglement.messages.noLettrageTooltip');
      }
      if (reglement.lettrages.find(l => l.lettrageType === this.constantes.ANNULATION_REGLEMENT)) {
        if (reglement.remiseBancaire.sens === SENS_VENTE && reglement.debit > reglement.credit) {
          return this.$t('annulerReglement.messages.cancelationReglementTooltip');
        }
        return this.$t('annulerReglement.messages.alreadyCancelledTooltip');
      }
      return this.$t('annulerReglement.tooltip');
    },
    editReglementByPiece(reglement) {
      const reglementToSend = {
        idRemiseBancaire: reglement.remiseBancaireId,
        idReglement: reglement.id,
        erreur: false,
      };
      this.$emit('editReglementByPiece', reglementToSend);
    },
    addReglementByPiece() {
      const reglementToSend = {
        idRemiseBancaire: this.remiseBancaire.id,
        erreur: false,
      };
      this.$emit('editReglementByPiece', reglementToSend);
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    handleAction(action) {
      switch (action) {
        case ACTION_DELETE:
          if (this.checkPermissions(REMISES_BANCAIRES.supprimer)) {
            this.suppressionSelection();
          } else this.showPopUp();
          break;
        case ACTION_MASS_ANNULATION:
          if (this.checkPermissions(REMISES_BANCAIRES.maj)) {
            this.annulationSelection();
          } else this.showPopUp();
          break;
        default: break;
      }
    },
    closePopUpSuppression() {
      this.popUpSuppression = false;
      this.reglementASupp = [];
    },
    fermerPopupAnnulation() {
      this.popUpAnnulation = false;
      this.popUpSingleAnnulation = false;
      this.questions.find((q) => {
        return q.key === 'dateComptable';
      }).value = new Date();
      this.reglementAAnnuler = [];
      this.msgAvertissements = [];
      this.messagesPopup = [];
      this.messagesChampsVidePopup = [];
      this.champsVidePopup = [];
      this.errorPopup = false;
    },
    updateMouvementClient() {
      this.fermerPopupAnnulation();
      this.$emit('updateMouvementClient');
    },
    selectionReglement(value) {
      const ligne = this.detailRemiseBancaireFilter.find((item) => {
        return item.id === value.id;
      });
      ligne.selected = !value.selected;
    },
    suppressionSelection() {
      this.reglementASupp = this.detailRemiseBancaireFilter.filter((el) => {
        return el.selected;
      });
      this.popUpSuppression = true;
    },
    annulationSelection() {
      this.reglementAAnnuler = this.detailRemiseBancaireFilter.filter((el) => {
        return el.selected;
      });
      this.popUpAnnulation = true;
      this.msgAvertissements = [];
      this.msgAvertissements.push({
        message: 'annulerReglement.warning',
      });
    },
    singleReglementDelete(dataASupprimer) {
      this.reglementASupp = [];
      this.reglementASupp.push(dataASupprimer);
      this.popUpSuppression = true;
    },
    cancelSinglePayment(data) {
      this.reglementAAnnuler = [];
      this.reglementAAnnuler.push(data);
      this.popUpSingleAnnulation = true;
    },
    async deleteReglement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let promises = [];
        this.popUpSuppression = false;
        /* On récupère les réglement lettré */
        const regLettre = this.reglementASupp.filter((reg) => reg.lettrages.length > 0);
        if (regLettre.length > 0) {
          regLettre.forEach(reg => {
            /* Pour chaque élément, on met le montant
            de chaque lettrage à 0
            puis on sauvegarde les lettrages */
            reg.lettrages.forEach(lettrage => {
              lettrage.montant = 0;
            });
            promises.push(saveLettrage({ lettrages: reg.lettrages }));
          });
          await Promise.all(promises);
          promises = [];
        }
        this.reglementASupp.forEach((el) => {
          promises.push(deleteReglement(el.id));
        });
        let successCount = 0;
        await Promise.all(promises).then(values => {
          values.forEach(response => {
            if (response.data.success) {
              successCount += 1;
            }
          });
        });
        await Promise.all(promises);
        if (successCount > 1) {
          messageSucces(successCount + ' ' + this.$t('supprimerReglement.reglementSupprimeMult'));
        } else {
          messageSucces(successCount + ' ' + this.$t('supprimerReglement.reglementSupprime'));
        }
        this.reglementASupp = [];
        this.$emit('updateMouvementClient');
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async cancelReglement(questions) {
      const dateCompta = questions.find((q) => {
        return q.key === 'dateComptable';
      }).value;
      this.error = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulerPaiementsAsync(this.reglementAAnnuler.map(r => r.id),
          null, null,
          formatIsoDate(dateCompta));
        this.reglementAAnnuler = [];
        this.msgAvertissements = [];
        this.fermerPopupAnnulation();
        this.$emit('updateMouvementClient');
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.messagesPopup = [];
          this.messagesChampsVidePopup = [];
          this.champsVidePopup = [];
          validationReglement(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVidePopup,
            this.messagesPopup, this.messagesChampsVidePopup, translate);
          this.errorPopup = true;
        } else messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    if (!this.isDetail) {
      this.actions.push({ action: ACTION_DELETE, translation: 'remiseBancaire.dataTable.delete' });
    }
    this.actions.push({ action: ACTION_MASS_ANNULATION, translation: 'remiseBancaire.dataTable.cancel' });
    this.questions = [{
      key: 'dateComptable',
      type: 'date',
      value: new Date(),
      message: 'annulerReglement.dateComptable',
      obligatoire: true,
    }];
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    isReglementSelected() {
      return this.detailRemiseBancaireFilter.some(item => item.selected);
    },
    allReglementSelected() {
      return this.detailRemiseBancaireFilter.length > 0
        && !this.detailRemiseBancaireFilter.some(item => !item.selected);
    },
    estValide() {
      return this.remiseBancaire.etat === VALIDE;
    },
    messHeaderSuppression() {
      return this.reglementASupp.length > 1 ? this.$t('supprimerReglement.deleteMultiple') : this.$t('supprimerReglement.delete');
    },
    messFooterSuppression() {
      return this.reglementASupp.length > 1 ? this.$t('supprimerReglement.irreversibleMultiple') : this.$t('supprimerReglement.irreversible');
    },
    messHeaderAnnulation() {
      return this.reglementAAnnuler.length > 1 ? this.$t('annulerReglement.cancelMultiple') : this.$t('annulerReglement.cancel');
    },
    messFooterAnnulation() {
      return this.reglementAAnnuler.length > 1 ? this.$t('annulerReglement.infoMultiple') : this.$t('annulerReglement.info');
    },
    detailRemiseBancaireFilter() {
      return this.detailRemiseBancaire.filter(item => {
        const fields = [
          item.ligneRemiseBancairePseudoEntity.referenceReglement,
          item.tiers.nomCommercial,
          item.ligneRemiseBancairePseudoEntity.emetteur,
        ];
        for (let i = 0; i < fields.length; i += 1) {
          if (fields[i] && fields[i].toLowerCase().includes(this.filter.toLowerCase())) {
            return true;
          }
        }
        return false;
      });
    },
    targetTotal() {
      return ['montant'];
    },
    iconSelectTotal() {
      if (this.allReglementSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          'ligneRemiseBancairePseudoEntity.referenceReglement': this.$t('remiseBancaire.detailRemiseBancaire.referenceTire'),
          'ligneRemiseBancairePseudoEntity.emetteur': this.$t('remiseBancaire.detailRemiseBancaire.nomTire'),
          dateMouvement: this.$t('remiseBancaire.detailRemiseBancaire.dateReglement'),
          dateEffet: this.$t('remiseBancaire.detailRemiseBancaire.dateEffet'),
          montant: this.$t('remiseBancaire.detailRemiseBancaire.montant'),
          nomCommercial: this.$t('remiseBancaire.detailRemiseBancaire.client'),
          commentaire: this.$t('remiseBancaire.detailRemiseBancaire.commentaire'),
          cancelPayment: '',
          delete: '',
          edit: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allReglementSelected;
                    this.detailRemiseBancaireFilter.forEach(item => {
                      item.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        childRow: childRowDetailReglementVente,
        columnsClasses: {
          selected: 'colonneSelected',
          delete: 'colonneSelected',
          edit: 'colonneSelected',
          commentaire: 'colonneWidth270px',
        },
        sortable: ['ligneRemiseBancairePseudoEntity.referenceReglement', 'nomCommercial', 'ligneRemiseBancairePseudoEntity.emetteur', 'dateMouvement', 'dateEffet', 'montant', 'commentaire'],
        orderBy: {
          column: 'creationTime',
          ascending: true,
        },
      };
    },
    columns() {
      const columns = ['ligneRemiseBancairePseudoEntity.emetteur', 'ligneRemiseBancairePseudoEntity.referenceReglement', 'nomCommercial', 'dateMouvement', 'dateEffet', 'montant', 'commentaire', 'nature'];
      columns.unshift('selected');
      // ordre des colonnes
      if (!this.isDetail) {
        columns.push('edit');
      }
      columns.push('cancelPayment');
      if (!this.isDetail) {
        columns.push('delete');
      }
      return columns;
    },
  },
};
</script>
